import { useEffect } from 'react';
import { connect } from 'react-redux';
import queryString from 'query-string';
import { withRouter } from 'react-router';
import { replace } from 'react-router-redux';

import { showModal } from '../../../services/modal/actions';
import { MODAL_TYPE_LOGIN_ERROR } from '../../../services/modal/constants';

// URL courante sans le paramètre ?error (les autres paramètres, ex. show, sont conservés)
const withoutErrorParam = location => {
    const params = queryString.parse(location.search);
    delete params.error;
    const search = queryString.stringify(params);

    return `${location.pathname}${search ? `?${search}` : ''}`;
};

/**
 * Ouvre la modale d'erreur de connexion (LoginErrorModal) quand l'URL de la page
 * contient un code ?error=X renvoyé par le back au retour du SSO (Fnac ou Darty).
 * À poser sur les pages cibles des redirections d'erreur : LoginChoicePage (seule
 * page routée ; LoginPage et RegisterPage, formulaires Darty décâblés, le montent
 * aussi). Ne rend rien.
 */
const LoginErrorModalTrigger = ({ error, location, showModal, replaceUrl }) => {
    useEffect(() => {
        if (error) {
            showModal(MODAL_TYPE_LOGIN_ERROR, {
                errorCode: error,
                // à la fermeture, on retire ?error de l'URL pour ne pas rouvrir la modale au rechargement
                actionOnClose: () => replaceUrl(withoutErrorParam(location))
            });
        }
    }, [error]);

    return null;
};

const mapStateToProps = (state, ownProps) => {
    return {
        error: queryString.parse(ownProps.location.search).error
    };
};

const mapDispatchToProps = {
    showModal,
    replaceUrl: replace
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(LoginErrorModalTrigger));



// WEBPACK FOOTER //
// ./src/components/authentication/loginerror/LoginErrorModalTrigger.js